import angular = require("angular");

import { UrlService } from '@uirouter/core';

import coreModule = require("./core/core.module");
import layoutModule = require("./layout/layout.module");
import activitiesModule = require("./activities/activities.module");
import resourcesModule = require("./resources/resources.module");
import listsModule = require("./lists/lists.module");

import uiCore = require("./core/uicore");
import dataCore = require("./core/datacore");

import componentsInstaller = require("./components/components.installer");
import reportsInstaller = require("./reports/reports.installer");
import resourcesInstaller = require("./resources/resources.installer");

import { downgradeInjectable } from '@angular/upgrade/static';

//Pages
import errorpage = require("./core/errorpage");
import { Principal } from "./shared/auth/principal.service";
import { AuthServerProvider } from "./shared/auth/auth.service";
import { LoginService } from "./shared/auth/login.service";
import { CrewEventManager } from "./shared/event-manager.service";
import { AuthJsInterceptor } from "./blocks/interceptor/authjs.interceptor";
import { MatSnackBar, MatDialog } from "@angular/material";
import { Auth401Service } from "./shared/auth/auth401.service";
import { SnackBarService } from "./shared/snackbar.service";
import { CrewPermissionsService } from "./core/crew-permissions.service";

var pages: uiCore.IStandardPageDirectiveClass[] = [
    errorpage.ErrorPage
];

var appFilters: uiCore.IFilterModuleDescription[] = [

].concat(dataCore.commonFilters);

var appConverters: uiCore.IConverterModuleDescription[] = [

].concat(dataCore.commonConverteres);

// Module Installers
var installers: uiCore.IInstaller[] = [
    new componentsInstaller.ComponentsInstaller(),
    new reportsInstaller.ReportsInstaller(),
    new resourcesInstaller.ComponentsInstaller()
];

export function initialize(): ng.IModule {
    var registeredApplicationModuleIds: string[] = [];

    // Initialize feature modules
    coreModule.initialize();
    layoutModule.initialize();
    activitiesModule.initialize();
    resourcesModule.initialize();
    listsModule.initialize();

    // Pages
    for (var i = 0; i < pages.length; i++) {
        uiCore.registerPageModule(registeredApplicationModuleIds, pages[i]);
    }

    // Filter modules
    for (var i = 0; i < appFilters.length; i++) {
        uiCore.registerFilterModule(registeredApplicationModuleIds, appFilters[i]);
    }

    // Converter modules
    for (var i = 0; i < appConverters.length; i++) {
        uiCore.registerConverterModule(registeredApplicationModuleIds, appConverters[i]);
    }

    // Run all Installers
    for (var i = 0; i < installers.length; i++) {
        installers[i].install(registeredApplicationModuleIds);
    }

    var appModule = angular
        .module("app", [

            /*
             * Common
             */
            "ngResource",
            "app.core",
            "angular.filter",
            "angular-loading-bar",
            "ngAnimate",

            /*
             * Features areas
             */
            "app.layout",
            "app.activities",
            "app.resources",
            "app.lists"
        ].concat(registeredApplicationModuleIds))
        .run(['$rootScope', '$state', '$stateParams',
            ($rootScope, $state, $stateParams) => {
                $rootScope.$state = $state;
                $rootScope.$stateParams = $stateParams;
            }
        ])
        .service("loginService", downgradeInjectable(LoginService))
        .service("crewEventManager", downgradeInjectable(CrewEventManager))
        .service("authServerProvider", downgradeInjectable(AuthServerProvider))
        .service("dialog", downgradeInjectable(MatDialog))
        .service("snackBar", downgradeInjectable(MatSnackBar))
        .service("snackBarService", downgradeInjectable(SnackBarService))
        .service("principal", downgradeInjectable(Principal))
        .service("auth401Service", downgradeInjectable(Auth401Service))
        .service("crewPermissionsService", downgradeInjectable(CrewPermissionsService));

    appModule.config(['$urlServiceProvider', ($urlService: UrlService) => $urlService.deferIntercept()]);
    appModule.config(['$httpProvider', ($httpProvider) => $httpProvider.interceptors.push(AuthJsInterceptor.Factory)]);

    return appModule;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/app.module.ts